import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CommunityActivity = ({ activities, upcomingEvents }) => {
  const handleActivityClick = (activity) => {
    if (activity?.type === 'forum') {
      window.location.href = '/community-forums';
    } else if (activity?.type === 'event') {
      window.location.href = '/events-and-workshops';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-wellness">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-heading font-semibold text-foreground">Community Activity</h2>
        <button 
          onClick={() => window.location.href = '/community-forums'}
          className="text-primary hover:text-primary/80 transition-wellness text-sm font-medium"
        >
          View All
        </button>
      </div>
      {/* Recent Activities */}
      <div className="space-y-4 mb-6">
        <h3 className="text-lg font-heading font-medium text-foreground">Recent Posts</h3>
        {activities?.slice(0, 3)?.map((activity, index) => (
          <div 
            key={index} 
            onClick={() => handleActivityClick(activity)}
            className="flex items-start space-x-3 p-3 rounded-lg hover:bg-muted/50 transition-wellness cursor-pointer border border-transparent hover:border-border"
          >
            <Image 
              src={activity?.avatar} 
              alt={activity?.author}
              className="w-10 h-10 rounded-full object-cover"
            />
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-1">
                <p className="text-sm font-medium text-foreground truncate">{activity?.author}</p>
                <div className="flex items-center space-x-1">
                  <Icon name={activity?.type === 'forum' ? 'MessageSquare' : 'Calendar'} size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{activity?.time}</span>
                </div>
              </div>
              <p className="text-sm text-muted-foreground line-clamp-2">{activity?.content}</p>
              <div className="flex items-center space-x-4 mt-2">
                <div className="flex items-center space-x-1">
                  <Icon name="Heart" size={14} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{activity?.likes}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="MessageCircle" size={14} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{activity?.replies}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Upcoming Events */}
      <div>
        <h3 className="text-lg font-heading font-medium text-foreground mb-3">Upcoming Events</h3>
        <div className="space-y-3">
          {upcomingEvents?.slice(0, 2)?.map((event, index) => (
            <div 
              key={index}
              onClick={() => window.location.href = '/events-and-workshops'}
              className="flex items-center space-x-3 p-3 rounded-lg bg-accent/5 border border-accent/10 hover:bg-accent/10 transition-wellness cursor-pointer"
            >
              <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="Calendar" size={20} color="white" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">{event?.title}</p>
                <div className="flex items-center space-x-2 mt-1">
                  <Icon name="Clock" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{event?.date} at {event?.time}</span>
                </div>
                <div className="flex items-center space-x-2 mt-1">
                  <Icon name="Users" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{event?.attendees} attending</span>
                </div>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CommunityActivity;